import React from 'react';
import { Search } from 'lucide-react';
interface SearchBarProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
}
export function SearchBar({
  searchQuery,
  onSearchChange
}: SearchBarProps) {
  return <div className="w-full bg-[#F2F2F2] border-b border-[#D5D5D5]" data-id="element-300">
      <div className="max-w-[1600px] mx-auto px-4 md:px-6 py-4" data-id="element-301">
        <div className="relative w-full max-w-full" data-id="element-302">
          <input type="text" value={searchQuery} onChange={e => onSearchChange(e.target.value)} placeholder="¿Qué tipo de auto estás buscando?" className="w-full h-14 pl-6 pr-14 rounded-full border border-[#C8C8C8] bg-white focus:outline-none focus:border-[#4A90E2] focus:ring-1 focus:ring-[#4A90E2] text-lg text-[#1C1C1C] placeholder-gray-400 shadow-sm transition-all" data-id="element-303" />
          <button className="absolute right-2 top-1/2 -translate-y-1/2 p-3 text-gray-500 hover:text-[#4A90E2] transition-colors rounded-full hover:bg-gray-100" data-id="element-304">
            <Search className="w-6 h-6" strokeWidth={1.5} data-id="element-305" />
          </button>
        </div>
      </div>
    </div>;
}